import { generatePath } from 'react-router-dom'
import { PRODUCT_INFO, PRODUCT_STOCK_TRACKING } from 'constants/app-paths'

export const productInfo = (id) => ([
  {
    label: 'Informações',
    link: generatePath(PRODUCT_INFO, { id }),
  },
  {
    label: 'Estoque',
    link: generatePath(PRODUCT_STOCK_TRACKING, { id }),
  },
])
